import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { LHHero } from '../components/laser-hair/LHHero';
import { LHWhatIs } from '../components/laser-hair/LHWhatIs';
import { LHBenefits } from '../components/laser-hair/LHBenefits';
import { LHHowItWorks } from '../components/laser-hair/LHHowItWorks';
import { LHManaging } from '../components/laser-hair/LHManaging';
import { LHResults } from '../components/laser-hair/LHResults';
import { LHFAQ } from '../components/laser-hair/LHFAQ';
import { LHWhyChoose } from '../components/laser-hair/LHWhyChoose';
export function LaserHairRemovalPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2566">
      <Navigation data-id="element-2567" />
      <main data-id="element-2568">
        <LHHero data-id="element-2569" />
        <LHWhatIs data-id="element-2570" />
        <LHBenefits data-id="element-2571" />
        <LHHowItWorks data-id="element-2572" />
        <LHManaging data-id="element-2573" />
        <LHResults data-id="element-2574" />
        <LHFAQ data-id="element-2575" />
        <LHWhyChoose data-id="element-2576" />
      </main>
      <Footer data-id="element-2577" />
    </div>;
}